export const hasCredit = (creditLimit: string) => {
  return creditLimit !== 'HKD$0.00';
}
